let depth = 0;

/** True while the app itself — not the user — is changing the active theme. */
export const isSystemThemeChange = () => depth > 0;

/**
 * Marks a theme change as app-initiated so that listeners can tell it apart
 * from a deliberate user switch.
 */
export function runSystemThemeChange(change: () => void) {
  depth += 1;
  try {
    change();
  } finally {
    depth -= 1;
  }
}
